import { useState, type ReactNode } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

interface QuickBooksCallbackParams {
  code: string | null;
  state: string | null;
  realmId: string | null;
}

interface QuickBooksCallbackResponse { message?: string }

export function QuickbooksCallbackViewModel(logout: () => void) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState<{ open: boolean; childComponent: ReactNode }>({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title: string, subtitle?: string) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent setOpen={setEmptyModelOpen} subtitle={subtitle} title={title} />
      ),
      open: true,
    });
  };

  const onStartCallback = async function (params: QuickBooksCallbackParams) {
    // params can be an object like { code, state, realmId }
    setLoading(true);
    let callResult;

    callResult = await makePostApiCall<QuickBooksCallbackResponse, QuickBooksCallbackParams>(`quickbooks/callback`, params);
    console.log("quickbooks callback result", callResult);
    setLoading(false);
    if (callResult.success) {
      showSuccess(callResult.data.message || "Quickbooks Connected");
      return true;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not Finish Quickbooks Connection", callResult.data.message);
      return false;
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    onStartCallback,
  };
}
